import React from 'react';
import { Label, Icon } from 'semantic-ui-react'
import moment from 'moment'

import UpdateTagsModal from '../modals/update_tags'
import TagComponent from '../tag_component'
import CopyIcon from '../copy_icon';

import { hasInvalidTrainingModuleDetails, getCategoryText, getDefaultFrequencyText } from '../../../helpers';

class V2TrainingModulesTable extends TagComponent {
  constructor(props){
    super(props);
    this.state = {
      v2TrainingModules: [],
      updateModalShown: false
    }
  }

  shouldComponentUpdate(nextProps, nextState){
    if (nextProps.render){
      return true;
    }
    else {
      return false;
    }
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.v2TrainingModules !== this.props.v2TrainingModules){
      this.setState({
        v2TrainingModules: nextProps.v2TrainingModules
      })
    }

  }

  onAdd = (evt, trainingModule, tag, context) => {
    evt.stopPropagation()
    if(context === 'tags' && tag.length > 0){
      this.addToTagList(tag, trainingModule)
    }
    else if(context === 'regions' && tag.length > 0){
      this.addToRegionList(tag, trainingModule)
    }
  }


  onRemove = (evt, trainingModule, tag, context) => {
    evt.stopPropagation()
    if (context === 'tags'){
      this.removeFromTagList(tag, trainingModule)
    }
    else if (context === 'regions'){
      this.removeFromRegionList(tag, trainingModule)
    }
  }

  showUpdateModal = (trainingModule) => {
    const { userIsAdmin } = this.props;
    const hasInvalidDetails = hasInvalidTrainingModuleDetails(trainingModule);

    if (!userIsAdmin || hasInvalidDetails) return;

    this.setState({
      updateModalShown: true,
      trainingModule: trainingModule
    })
  }

  onTeamClick = (evt, obj) => {
    evt.stopPropagation()
    this.props.onTeamClick(evt, obj)
  }

  onMenuEventHandler = (evt, trainingModule) => {
    const { userIsAdmin, setSelectedRow } = this.props;

    if (!userIsAdmin) return;

    setSelectedRow(trainingModule)
    let contextmenu_id
    if(trainingModule.archived){
      contextmenu_id = 'archived_table_row_contextmenu'
    } else {
      contextmenu_id = 'table_row_contextmenu'
    }

    evt.preventDefault();
    evt.stopPropagation();
    this.closeAllTableContextMenu()

    let element = document.getElementById(contextmenu_id);
    this.autoPositionElement(evt, element);

  }

  closeTableContextMenu = (contextmenu_id) => {
    let menu = document.getElementById(contextmenu_id);
    menu.style.cssText = 'visibility: hidden;';
  }

  closeAllTableContextMenu = () => {
    this.closeTableContextMenu('table_column_contextmenu')
    this.closeTableContextMenu('table_row_contextmenu')
    this.closeTableContextMenu('archived_table_row_contextmenu')
  }

  renderModuleDetails = (trainingModule) => {
    const category = getCategoryText(trainingModule.category);
    const default_frequency = getDefaultFrequencyText(trainingModule.default_frequency);
    const shec_discipline = trainingModule.shec_discipline ? `${trainingModule.shec_discipline}` : '';
    const delivery = trainingModule.delivery ? `${trainingModule.delivery}` : '';
    const run_time = trainingModule.run_time ? `${trainingModule.run_time} hours` : '';
    const should_be_in_bracket = category.length > 0 || default_frequency.length > 0 || shec_discipline.length > 0 || delivery.length > 0 || run_time.length > 0;

    const countryList = trainingModule.region_list || [];
    const countryDesc = countryList.length > 0 ? `: Country Specific` : '';

    return (
      <React.Fragment>
        {
          should_be_in_bracket && <span>(</span>
        }
        {
          category.length > 0 && <span className='category'>{category} {countryDesc}</span>
        }
        {
          category.length > 0 && default_frequency.length > 0 && <span className='divider'>, </span>
        }
        {
          default_frequency.length > 0 && <span className='default-frequency'>{default_frequency}</span>
        }
        {
          (category.length > 0 || default_frequency.length > 0) && shec_discipline.length > 0 && <span className='divider'>, </span>
        }
        {
          shec_discipline.length > 0 && <span className='shec-discipline'>{shec_discipline}</span>
        }
        {
          (category.length > 0 || default_frequency.length > 0 || shec_discipline.length > 0) && delivery.length > 0 && <span className='divider'>, </span>
        }
        {
          delivery.length > 0 && <span className='delivery'>{delivery}</span>
        }
        {
          (category.length > 0 || default_frequency.length > 0 || shec_discipline.length > 0 || delivery.length > 0) && run_time.length > 0 && <span className='divider'>, </span>
        }
        {
          run_time.length > 0 && <span className='run-time'>{run_time}</span>
        }
        {
          should_be_in_bracket && <span>)</span>
        }
      </React.Fragment>
    )
  }

  render() {
    const { v2TrainingModules } = this.state
    const { className, heading, mode, type, tagName, tags, regions, userIsAdmin } = this.props
    return (
      <div className={`training-modules-table ${className}`}>
        {
          heading &&
          <div className='training-modules-table-heading '>
            { heading }
          </div>
        }
        <div className='training-modules-table-head-row'>
          <div key='name' className='training-modules-table-name'>Training Module Name</div>
        </div>
        {
          v2TrainingModules.length > 0 &&
          v2TrainingModules.map((trainingModule, i)=>{
            let archived_date = trainingModule.archived_date ? `Archived (${moment(trainingModule.archived_date).format("DD-MM-YYYY")})` : 'Archived';
            return(
              <div
                key={trainingModule.id}
                className='training-modules-table-data-row'
                onContextMenu={evt=>this.onMenuEventHandler(evt, trainingModule)}
              >
                <div key={`name-${trainingModule.id}`} className='training-modules-table-name'>
                  {
                    trainingModule.link
                    ?
                    <div>
                      <a onClick={(evt)=>evt.stopPropagation()} href={trainingModule.link} target='_blank'>{trainingModule.name}</a>
                      <CopyIcon value={trainingModule.link}/>
                    </div>
                    :
                    <div>
                      { trainingModule.name }
                    </div>
                  }
                  <div className="module-details">
                    { this.renderModuleDetails(trainingModule) }
                  </div>
                  <div style={{color:'#ff0000', fontStyle: 'italic'}}>{trainingModule.archived ? archived_date : ''}</div>
                  <div>
                    {
                      trainingModule.tag_list.length > 0 &&
                      trainingModule.tag_list.map((tag, j)=>{
                        return(
                          <Label key={tag} value={tag} onClick={(evt)=>this.onTeamClick(evt, {value: tag, tag_type:'custom-tag'})}>
                            {tag}
                          </Label>
                        )
                      })
                    }
                    {
                      trainingModule.region_list.length > 0 &&
                      trainingModule.region_list.map((region, j)=>{
                        return(
                          <Label className='region' key={region} value={region} onClick={(evt)=>this.onTeamClick(evt, {value: region, tag_type:'region-tag'})}>
                            {region}
                          </Label>
                        )
                      })
                    }
                  </div>
                </div>
                {
                  mode === 'edit' && type === 'all' &&
                  <div className='training-modules-table-action' onClick={(evt)=>this.onAdd(evt, trainingModule, tagName, 'tags')}>
                    <Icon name='plus'/>
                  </div>
                }
                {
                  userIsAdmin &&
                  <div className='training-modules-table-action three-dots' onClick={evt=>this.onMenuEventHandler(evt, trainingModule)}>
                    <Icon name='ellipsis vertical'/>
                  </div>
                }
              </div>
            )
          })
        }
        {
          v2TrainingModules.length === 0 && !this.props.fetchingTrainingModules &&
          <div className='training-modules-table-no-result'>
            No result found.
          </div>
        }
        {
          v2TrainingModules.length === 0 && this.props.fetchingTrainingModules &&
          <div className="loading-message">
            <i className="loading circle notched icon"></i>
            <span>Loading training modules...</span>
          </div>
        }
        {
          this.state.updateModalShown &&
          <UpdateTagsModal
            show={this.state.updateModalShown}
            onClose={()=>this.setState({ updateModalShown: false })}
            tags={tags}
            regions={regions}
            tagged_item={this.state.trainingModule}
            updateTags={this.props.updateTags}
          />
        }
      </div>
    )
  }
}

export default V2TrainingModulesTable;



// WEBPACK FOOTER //
// ./src/views/components/tables/v2_training_modules_table.js